import Vue from 'vue'
import UserMixin from '@/components/helpers/mixins/user-mixin'

export default Vue.extend({
  template: `
    <b-img
        :src="avatar"
        class="contact-avatar"
        rounded="circle"
        alt="Аватар"
        width="50"
        height="50"
        @click="goToProfile"
        @error="$event.target.src = defaultImage"
        :style="{cursor: cursorStyle}"
    />
  `,
  mounted() {
    if (this.$route.path.includes('student/list') && this.params.data && this.params.data.active) {
      this.cursorStyle = 'pointer'
    }
  },
  data() {
    return {
      defaultImage: '/images/account/default.jpg',
      cursorStyle: ''
    }
  },
  computed: {
    avatar() {
      let avatarFile = ''
      if (!this.$route.name.includes('ChatsPage')) {
        avatarFile = this.params.data.avatarFile
      } else if (this.params.context.componentParent.currentUser.id === this.params.data.senderId) {
        avatarFile = this.params.data.receiver.avatarFile
      } else {
        avatarFile = this.params.data.sender.avatarFile
      }
      return this.$_userMixin_getAvatar(avatarFile)
    }
  },
  methods: {
    goToProfile() {
      if (this.params.data.active && this.$route.path.includes('student/list')) {
        this.$router.push(`/student/list/${this.params.data.id}`)
      }
    }
  },
  mixins: [UserMixin]
})
